export default __webpack_public_path__ + "static/media/iphone.e3df41bd.png";